// extracted by mini-css-extract-plugin
module.exports = {"message":"style_message__3F5A9"};